/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface PurchaseCostCoverageItemData
 */
export interface PurchaseCostCoverageItemData {
    /**
     * 
     * @type {string}
     * @memberof PurchaseCostCoverageItemData
     */
    name?: string;
    /**
     * 
     * @type {PurchaseCostCoverageItemDataReasonEnum}
     * @memberof PurchaseCostCoverageItemData
     */
    reason?: PurchaseCostCoverageItemDataReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof PurchaseCostCoverageItemData
     */
    sourceOrderLineId?: string | null;
    /**
     * Signed exact row net sales value in the project/report currency. Null means the row sales value is unavailable.
     * @type {MoneyOutput}
     * @memberof PurchaseCostCoverageItemData
     */
    saleValue?: MoneyOutput | null;
    /**
     * Stored net sales price for one unit in the project/report currency. This is the stored unit price and is not derived from the row total or quantity.
     * @type {MoneyOutput}
     * @memberof PurchaseCostCoverageItemData
     */
    salePricePerUnit?: MoneyOutput | null;
}


/**
 * @export
 */
export const PurchaseCostCoverageItemDataReasonEnum = {
    Missing: 'missing'
} as const;
export type PurchaseCostCoverageItemDataReasonEnum = typeof PurchaseCostCoverageItemDataReasonEnum[keyof typeof PurchaseCostCoverageItemDataReasonEnum];


/**
 * Check if a given object implements the PurchaseCostCoverageItemData interface.
 */
export function instanceOfPurchaseCostCoverageItemData(value: object): value is PurchaseCostCoverageItemData {
    return true;
}

export function PurchaseCostCoverageItemDataFromJSON(json: any): PurchaseCostCoverageItemData {
    return PurchaseCostCoverageItemDataFromJSONTyped(json, false);
}

export function PurchaseCostCoverageItemDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseCostCoverageItemData {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'sourceOrderLineId': json['sourceOrderLineId'] === undefined ? undefined : json['sourceOrderLineId'] === null ? null : json['sourceOrderLineId'],
        'saleValue': json['saleValue'] === undefined ? undefined : json['saleValue'] === null ? null : MoneyOutputFromJSON(json['saleValue']),
        'salePricePerUnit': json['salePricePerUnit'] === undefined ? undefined : json['salePricePerUnit'] === null ? null : MoneyOutputFromJSON(json['salePricePerUnit']),
    };
}

export function PurchaseCostCoverageItemDataToJSON(json: any): PurchaseCostCoverageItemData {
    return PurchaseCostCoverageItemDataToJSONTyped(json, false);
}

export function PurchaseCostCoverageItemDataToJSONTyped(value?: PurchaseCostCoverageItemData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'reason': value['reason'],
        'sourceOrderLineId': value['sourceOrderLineId'],
        'saleValue': MoneyOutputToJSON(value['saleValue']),
        'salePricePerUnit': MoneyOutputToJSON(value['salePricePerUnit']),
    };
}

